/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskDetails } from '@/task-manager/entities/task-details';

import { type BodyOf, tasksV1CardsContactCreate } from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace NotifyAccure {
  export type Input = Pick<TaskDetails, 'id'>;
  export type Output = void;

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsContactCreate> {
    return {
      uuid: input.id,
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CardsContactCreate(body, opts));
        return;
      },
    });
  }
}
